import { TypeAnimation } from 'react-type-animation';

const PlaceHolder = () => {
  return (
    <TypeAnimation
      sequence={[
        'Start Your Chat',
        1000,
        'Put Your Queries & Enjoy the tool!!!!!!!!!!!!',
        1000,
      ]}
      speed={50}
      style={{ fontSize: '1.5em' }}
      repeat={Infinity}
    />
  );
};

export default PlaceHolder;